import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  uploadItemValidate,
  upload,
} from "./roleAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk("role/fetchData", async (payload) => {
  const response = await getAll(payload);
  return response;
});

export const fetchRole = createAsyncThunk("role/fetchRole", async (payload) => {
  const response = await getAll(payload);
  return response;
});

export const fetchId = createAsyncThunk("role/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});

export const fetchIdNoloading = createAsyncThunk(
  "role/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  }
);

export const addItem = createAsyncThunk("role/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const editItem = createAsyncThunk("role/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});
export const removeById = createAsyncThunk(
  "role/removeById",
  async (payload) => {
    console.log(payload, "payload");
    const response = await deleteById(payload);
    return response;
  }
);

export const uploadValidate = createAsyncThunk(
  "product/uploadValidate",
  async (payload) => {
    const response = await uploadItemValidate(payload);
    return response;
  }
);
export const uploadItem = createAsyncThunk(
  "product/uploadItem",
  async (payload) => {
    const response = await upload(payload);
    return response;
  }
);

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchRole.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchRole.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(uploadValidate.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadValidate.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = roleSlice.actions;

export const selectData = (state) => state.role.data;
export const selectRole = (state) => state.role.data;
export const selectId = (state) => state.role.dataId;
export const selectLoading = (state) => state.role.loading;
export const selectError = (state) => state.role.error;
export const selectPageNo = (state) => state.role.pageNo;
export const selectPageSize = (state) => state.role.pageSize;
export const selectTotalRecord = (state) => state.role.totalRecord;
export const selectSelected = (state) => state.role.selected;
export const selectResult = (state) => state.role.result;

export default roleSlice.reducer;
